import React, { useState } from "react";
import Modal from 'react-modal';

const nameCheapUrl = "https://www.namecheap.com/domains/registration/results/?domain=";
const customStyles = { content: { backgroundColor: '#505ABC', color: '#fff', top: '50%', left: '53%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-60%, -50%)' }, };

const NameCard = (props) => {

    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => {setIsOpen(true)};
    const closeModal = () => {setIsOpen(false)};

    const addToFavorites = () => {
      var favorites = [];
      if(localStorage.getItem('favorites') !== null){
        favorites.push(localStorage.getItem('favorites'));
      }
      favorites.push(props.name);
      localStorage.setItem('favorites', favorites);
      setIsOpen(false);
    }

    return (
        <>
        <div className="my-3 w-full lg:w-3/12 px-4 lg:mt-16" style={{paddingTop:'30px'}}>
          <a className="card-link" onClick={openModal} >
          <div className="bg-white shadow-lg rounded-lg text-center p-8 mt- ">
            <img
              alt="..."
              className="shadow-md rounded-full max-w-full w-16 mx-auto p-2 bg-white"
              src="https://res.cloudinary.com/dek4evg4t/image/upload/v1638676717/favicon.png"
            />
            <p className="text-lg text-custom-purple mt-4 font-semibold">
              {props.name}
            </p>
          </div>
          </a>
        </div>
        <Modal 
          isOpen={isOpen}
          onRequestClose={closeModal}
          style={customStyles}
        >
            <h2><b>Startup Name Generator</b></h2>
            <form style={{marginTop:'20px'}}>
              <button onClick={addToFavorites} style={{marginRight:'20px', marginLeft:'100px', color:'#fff'}}> 
                <i className="fas fa-heart text-white"></i> Añadir a Favoritos
              </button>
              <button type="button" style={{color:'#fff'}}>
                <a href={`${nameCheapUrl}${props.name}`} target="_blank" rel="noreferrer"> 
                  <i className="fas fa-check text-white"></i> Ver disponibilidad 
                </a>
              </button>
            </form>
        </Modal>
        </>
    );
};

export default NameCard;
